import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  values: {
    companyName: "",
    email: "",
    phone: "",
    personName: "",
    designation: "",
    role: "",
    date: "",
    slot: "",
  },
  errors: {},
  submitted: false,
};

const validate = (values) => {
  const errors = {};
  if (!values.companyName) errors.companyName = "Company name is required";
  if (!values.personName) errors.personName = "Person name is required";
  if (!values.designation) errors.designation = "Designation is required";
  if (!values.phone) errors.phone = "Phone number is required";
  else if (!/^\+?\d{7,15}$/.test(values.phone))
    errors.phone = "Invalid phone number";
  if (!values.email) errors.email = "Email is required";
  else if (!/^\S+@\S+\.\S+$/.test(values.email))
    errors.email = "Invalid email address";
  if (!values.date) errors.date = "Date is required";
  if (!values.slot) errors.slot = "Slot is required";
  return errors;
};

export const jckFormSlice = createSlice({
  name: "jckForm",
  initialState,
  reducers: {
    updateField: (state, action) => {
      const { name, value } = action.payload;
      state.values[name] = value;
      state.errors = validate(state.values);
    },
    validateForm: (state) => {
      state.errors = validate(state.values);
    },
    resetForm: () => initialState,
    setSubmitted: (state, action) => {
      state.submitted = action.payload;
    },
  },
});

export const { updateField, validateForm, resetForm, setSubmitted } =
  jckFormSlice.actions;
export default jckFormSlice.reducer;
